import store from '@/store';
import { setError } from '@/actions';

const triggerErrorAlert = (errorMessage) => {
  store.dispatch(setError(200, '', 'error', false, errorMessage));
};

export default triggerErrorAlert;
